export default __webpack_public_path__ + "static/media/serv_diseno.099fa51c.jpg";